/*
 * Enable tooltips for footnotes that are embedded within html markup.
 * 
 * Note: Tooltips are injected via the TinyMCE FootNotes Plugin 
 *       from https://github.com/rainywalker/footNotes for fields
 *       that use the TinyMCE HTML editor.
 *
 */
$(function() {
    $('.fnoteBtn').each(function() {
        $(this).popover({
            html: true,
            trigger: 'hover focus',
            placement: 'auto'
        });
    });
});